import { useWatch } from 'react-hook-form';

import type { PartialSaveOptions } from 'payments/types/form';
import { useLocationId } from 'reservations/account/providers/ConfigProvider';
import { Booking } from 'reservations/booking/types';

export const useSaveCardOnFilePayload = (
  booking: Booking,
  shouldConfirmCardWithNextable: boolean,
  savedPaymentMethod?: string
) => {
  const { bookingId, email, firstName, lastName, phone, phoneCode } = booking;
  const locationId = useLocationId();

  const [optInChecklessPayments, tipPercentage] = useWatch({
    name: ['optInChecklessPayments', 'tipPercentage']
  });

  const payload: PartialSaveOptions = {
    locationId,
    bookingId,
    email,
    firstName,
    lastName,
    phone,
    phoneCode,
    shouldConfirmCardWithNextable,
    optInChecklessPayments,
    tipPercentage,
    ...(savedPaymentMethod && { savedPaymentMethod })
  };

  return payload;
};
